export default __webpack_public_path__ + "static/media/icon-book.993a61e9.svg";